export default __webpack_public_path__ + "static/media/dgm05-DataGovernancePlan(2007).45f0c1b2.pdf";